import ContainerSignUp from "./Components/ContainerSignUp";
import ContainerSignUpInfo from "./Components/ContainerSignUpInfo";
import ContainerSignUpPhone from "./Components/ContainerSignUpPhone";
import { useLayoutEffect, useState } from "react";

export default function SignUp() {
  const [signupData, setSignupData] = useState({
    email: "",
    password: "",
    password_again: "",
    phone_number: "",
    fn: "",
    ln: "",
    referral_code: "",
    birth_date: "",
    national_id: "",
  });
  const [step, setStep] = useState(1);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (step === 1) {
    return (
      <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark">
        <ContainerSignUp
          signupData={signupData}
          setSignupData={setSignupData}
          setStep={setStep}
          text="ایجاد حساب کاربری"
        />
        <span className="hidden absolute w-full h-[1px] bottom-16 bg-zi-gradient-divider"></span>
      </div>
    );
  }
  if (step === 2) {
    return (
      <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark">
        <ContainerSignUpPhone
          signupData={signupData}
          setSignupData={setSignupData}
          setStep={setStep}
          text="ایجاد حساب کاربری"
        />
        <span className="hidden absolute w-full h-[1px] bottom-16 bg-zi-gradient-divider"></span>
      </div>
    );
  }
  if (step === 3) {
    return (
      <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark">
        <ContainerSignUpInfo
          signupData={signupData}
          setSignupData={setSignupData}
          setStep={setStep}
          text="ایجاد حساب کاربری"
        />
        <span className="hidden absolute w-full h-[1px] bottom-16 bg-zi-gradient-divider"></span>
      </div>
    );
  }
}
